module.exports = "/_next/static/images/Plan-1-b7154287c81ac1eea3f88d4741188281.png";